import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { transferItemSelector } from "../../../../redux/selectors";
import { ItemHeaderProps } from "../../ItemHeader";
import { Skeleton } from "@material-ui/lab";
import { loadingFoi } from "../../../../redux/actions";
import {
  DialogDeciderActionTypes,
  TransferRecord,
} from "../../../../domain/TransferRecord";
import { CreateDecider } from "./CreateDecider";
import { ActionButtonRenderer } from "./ActionButtonRenderer";

export type ActionSelectorDialogProps = {
  itemHeaderProps: ItemHeaderProps;
  onClose: () => void;
  open: boolean;
  disabled: boolean;
};

const useStyles = makeStyles(() => ({
  dialog: {
    minWidth: "500px",
    padding: "20px",
  },
}));

export const ActionSelectorDialog: React.FC<ActionSelectorDialogProps> = ({
  itemHeaderProps: { state },
  onClose,
  open,
  disabled,
}) => {
  const item = state?.item;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [dialogAction, setDialogAction] = useState<TransferRecord>({
    module: DialogDeciderActionTypes.null,
  });
  const transferItem = useSelector(transferItemSelector);
  const loading: boolean = transferItem.status === "LOADING";

  const handleCreateFoi = () => {
    if (item !== undefined) {
      dispatch(loadingFoi(item.id));
      setDialogAction({ module: DialogDeciderActionTypes.FOI });
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onClose();
          setDialogAction({ module: DialogDeciderActionTypes.null });
        }}
        fullWidth
        maxWidth="md"
      >
        {!loading ? (
          <>
            {!disabled ? (
              <>
                {dialogAction.module === DialogDeciderActionTypes.null ? (
                  <DialogContent>
                    <List>
                      <ListItem
                        data-test="transfer-foi-modal-button"
                        button
                        onClick={() => handleCreateFoi()}
                      >
                        <ListItemText primary="FOI" />
                      </ListItem>
                    </List>
                  </DialogContent>
                ) : (
                  <>
                    {!!transferItem.item?.data === false ? (
                      <CreateDecider
                        item={item!}
                        action={dialogAction.module}
                      />
                    ) : (
                      <DialogContent data-test="validation-message">
                        A {DialogDeciderActionTypes[dialogAction.module]}{" "}
                        already exists for this SAR
                      </DialogContent>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <DialogContent
                  data-test="item-disabled-dialog"
                  className={classes.dialog}
                >
                  Item is either closed or cancelled and cannot be transferred.
                </DialogContent>
              </>
            )}
          </>
        ) : (
          <DialogContent className={classes.dialog}>
            <Skeleton variant="text" height={60} />
            <Skeleton variant="text" height={60} />
          </DialogContent>
        )}
        {!loading && (
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                onClose();
                setDialogAction({ module: DialogDeciderActionTypes.null });
              }}
              data-test="action-dialog-close-button"
            >
              Close
            </Button>
            {!!transferItem.item?.data && (
              <ActionButtonRenderer
                id={transferItem.item?.data}
                action={dialogAction.module}
              >
                Go to {DialogDeciderActionTypes[dialogAction.module]}
              </ActionButtonRenderer>
            )}
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};
